import React from "react";

function useMediaQuery({
	query,
	serverDefault,
}: { query: string; serverDefault: boolean }) {
	const subscribe = React.useCallback(
		(callback: () => void) => {
			const matchMedia = window.matchMedia(query);

			matchMedia.addEventListener("change", callback);
			return () => {
				matchMedia.removeEventListener("change", callback);
			};
		},
		[query],
	);

	const getSnapshot = () => {
		return window.matchMedia(query).matches;
	};

	const getServerSnapshot = () => {
		return serverDefault;
	};

	return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

const breakpoints = {
	md: "48rem",
};
export function useMininumDeviceWidthBreakpoint({
	breakpoint,
	serverDefault,
}: { breakpoint: keyof typeof breakpoints; serverDefault: boolean }) {
	return useMediaQuery({
		query: `(width >= ${breakpoints[breakpoint]})`,
		serverDefault,
	});
}
